
import { Lotto } from "./Lotto";


export const GhanaLotto = ({dataList, summary, loading, error}) => {
    console.log("Rendering GhanaLotto")

    return (  
        <Lotto
           gameName="Ghana Lotto" 
           dataList={dataList}
           summary={summary}
           loading={loading}
           error={error}
        />
    )
}